import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { ErrorBoundary } from "./components/errorBoundary";
import { RouteError } from "./components/routeError";
import { LoginSignUp } from "./views/loginSignUp";
import { HomePage } from "./views/homePage";
import { Reservation } from "./views/reservations/reservation";
import { PopupShop } from "./views/popupShop/popupShop";
import { PastCollaborations } from "./views/pastCollaborations";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import "./assets/css/fonts.css";

const suppressLogsInProduction = () => {
  if (process.env.REACT_APP_ENV === "prd") {
    const noop = () => { };
    console.debug = noop;
    console.log = noop;
    console.warn = noop;
    console.error = noop;
  }
};

suppressLogsInProduction();

const router = createBrowserRouter([
  {
    path: "/loginSignUp",
    element: <LoginSignUp isLoginToggle={true} />,
    errorElement: <RouteError />,
  },
  {
    path: "/",
    element: <HomePage />,
    errorElement: <RouteError />,
  },
  {
    path: "/reservation",
    element: <Reservation />,
    errorElement: <RouteError />,
  },
  {
    path: "/popupShop",
    element: <PopupShop />,
    errorElement: <RouteError />,
  },
  {
    path: "/pastCollaborations",
    element: <PastCollaborations />,
    errorElement: <RouteError />,
  },
]);

export default function App() {
  useEffect(() => {
    if (process.env.REACT_APP_ENV === "prd") {
      const disableRightClick = (event) => event.preventDefault();
      document.addEventListener("contextmenu", disableRightClick);
      return () => {
        document.removeEventListener("contextmenu", disableRightClick);
      };
    }
  }, []);

  return (
    <div>
      <ErrorBoundary>
        <RouterProvider router={router} />
        <ToastContainer className="toast-container" closeButton={false} />
      </ErrorBoundary>
    </div>
  );
}
